import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';

import { routes } from './app.routes';
import { AppModule } from './app.module';

// Factory to ensure MSAL is initialized before the app starts
function initializeMsal(msalService: MsalService): () => Promise<void> {
  return () => {
    return msalService.instance.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Modern standalone HTTP client with interceptor compatibility
    provideHttpClient(withInterceptorsFromDi()),
    // Import all providers from AppModule (MSAL, guards, interceptors, etc.)
    importProvidersFrom(AppModule),
    // Ensure MSAL is initialized before app starts
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true
    }
  ]
};
